import { render, staticRenderFns } from "./RecordCopyToEdit.vue?vue&type=template&id=0c84c7e5"
import script from "./RecordCopyToEdit.vue?vue&type=script&lang=js"
export * from "./RecordCopyToEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports